//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import BScroll from 'better-scroll'
import { rateHead,rateTable } from '@/model/javaApi/detail.js';
import  Selectlist  from '@/views/stencil/components/from/selectlist'
import  XTable  from '@/components/common/x-table'
export default {
    data(){
        return {
            selectData:[],
            tableLabel:[],
            tableData:[],
            rateScroll :null,
        }
    },
    props:{
        productCode:{
            type:String,
            required:true
        }
    },
    components:{
        Selectlist,
        XTable
    },
    created(){
       this.getData();
    },
    mounted(){
    },
    methods: {
        // // 初始化BScroll
        // init() {
        //     this.rateScroll = new BScroll(this.$refs.rateScroll, {
        //         click: true,
        //         scrollX: true
        //     })
        // },
        getData(){
            // 获取费率表头 
            rateHead({productCode:this.productCode}).then(res =>{
                this.selectData=res.map(item=>{
                    const choices=[...item.choices];
                    item.choices=choices.map(choice=>({label:choice,value:choice}));
                    item.title=item.choices[0].value;
                    return item;
                })
                this.getTableData();
                // this.init();
            })
        },
        input(value,item){
            item.title=value;
            this.getTableData();
        },
        getTableData(){
            let selectItems=[];
            this.selectData.forEach(ele => {
                selectItems.push({
                    isCount:1,
                    optionCode:ele.code,
                    optionValue:ele.title,
                    ruleEnum:ele.ruleEnum
                })
            });
            // 获取费率表
            rateTable({productCode:this.productCode,selectItems:[...selectItems]}).then(res =>{
                this.tableLabel=res.topName;
                this.tableData=res.priceList;
            })
        }
    },
}
